import React from 'react';


import './testimonials.css';

import TestimonialItem from './testimonialItem/testimonialItem'

import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useState } from 'react';

import bulb from '../../assets/bulbAsset.png'
import ross from '../../assets/rossProfile.jpg'

import defaultPic from '../../assets/defaultProfile.png'

function Testimonials() {

    const [currentIndex, setIndex ] = useState(0);

//Taylor is a great Liquid HTML developer. We provided the outline of what we were looking for, and Taylor executed against our needs extremely well!
    
  let testimonialList = [(<TestimonialItem quote="I hired Taylor for a small project originally and it didn’t take long for me to see that he truly is a master in his field. He finished my first project so quickly and thoroughly that I hired him to build a very extensive custom web app for my company (www.UnrefinedArt.com). This app is a one-of-a-kind program that has never been done before and he completely knocked it out of the park. So far I haven’t found anything that he can’t do. I bring ideas and dreams to him and his answer is always “Yeah, I can do that”. You will find Taylor to be extremely knowledgeable, kind, and honest. He is a problem solver and has great communication, which you don’t always find in this market. If you hire him, you will not be disappointed. "
                    name="Ross Sergio"
                    title="Owner - Unrefined Art"
                    image={ross}
                    >
    )]
  
</TestimonialItem>),

(<TestimonialItem quote="Taylor is a great Liquid HTML developer. We provided the outline of what we were looking for, and Taylor executed against our needs extremely well!"
name="Dustin Jiles"
title="Shiphawk"
image={defaultPic}
>
)]

</TestimonialItem>),
]

  function getViewClass(index){
      console.log("updatign view class")
      if(index < currentIndex){
          return "view--container left--view"
      }else if(index === currentIndex){
          return "view--container in--view"
      }else{
          return "view--container right--view"
      }
  }

  function goLeft(){
    console.log("decrmenting coutner")
    if(currentIndex > 0){
        setIndex (currentIndex - 1)
    }
    console.log("current index == ", currentIndex)
  }

  function goRight(){
      console.log("incrementing coutner")
    if(currentIndex < testimonialList.length - 1){
        setIndex (currentIndex + 1)
    }
    console.log("current index == ", currentIndex)
  }

  return (
    <div className="testimonials--container">
        <div className="testimonials--header">
            Testimonials
        </div>
        <div className="testimonials--sub--header">
            Not convinced? Check out some of our positively glowing reviews!
        </div>
        <div className="testimonials--sub--container">
            <div className={currentIndex === 0 ? "toggle out--of--bounds" : "toggle"}onClick={() => goLeft()}>
                <FontAwesomeIcon icon={faChevronLeft} />
            </div>
            <div className="card--container">
            {testimonialList.map((testimonial, index) => 
                <div className={ getViewClass(index)}>
                    {testimonial}
                </div>
            )
            }
            </div>
            <div className={currentIndex === (testimonialList.length - 1) ? "toggle out--of--bounds" : "toggle"} onClick={() => goRight()}>
                <FontAwesomeIcon icon={faChevronRight} />
            </div>
        </div>
    </div>
  );
}

export default Testimonials;
